import React from 'react';
import Snsbar from './Snsbar'

const Footer = () => {
  return(
    <footer>
      <h5>Portfolio</h5>
      <p>2020 All rights reserved.</p>

      <Snsbar color="white" />
    </footer>
  )
};

export default Footer